export type I18nText = Partial<Record<"fr" | "en" | "ar", string>> | undefined;

export const getLocalizedText = (i18nValue: I18nText, lang: string, fallback = ""): string => {
  const normalized = (lang || "fr").split("-")[0] as "fr" | "en" | "ar";
  if (!i18nValue) return fallback;
  return i18nValue[normalized] || i18nValue.fr || i18nValue.en || i18nValue.ar || fallback;
};

